
const menu = document.querySelector('.menu')

if (!window.matchMedia("(max-aspect-ratio: 2/3)").matches) {
  openSubmenu();   // portrait
} else {
  openToggleMenu(); // landscape
}

function openSubmenu () {
  document.querySelectorAll('.menu-item-first-generation').forEach(item => {
    const submenu = item.querySelector('.submenu');
    const icon = item.querySelector('.icon');

    if (!submenu) return;

    let closeTimer;

    const openMenu = () => {
      clearTimeout(closeTimer);
      submenu.classList.add('active');
      icon.classList.add('active');
    };

    const closeMenu = () => {
      closeTimer = setTimeout(() => {
        submenu.classList.remove('active');
        icon.classList.remove('active');
      }, 300);
    };

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);

    submenu.addEventListener('mouseenter', openMenu);
    submenu.addEventListener('mouseleave', closeMenu);
  });
}

function openToggleMenu () {

  const menu = document.querySelector('.menu')
  if (!menu) return;
  const menuToggle = menu.querySelector('.menu-toggle')
  if (!menuToggle) return;
  const menuList = menu.querySelector('.menu-list')
  if (!menuList) return;

  const iconMenu = menuToggle.querySelector('.icon-menu')
  const iconClose = menuToggle.querySelector('.icon-close')

  let closeTimer;
  const openToggle = () => {
    clearTimeout(closeTimer);
    iconMenu.classList.toggle('show');
    iconClose.classList.toggle('show');
    menuList.classList.toggle('show');
  }

  const closeToggle = () => {
    closeTimer = setTimeout(() => {
      iconMenu.classList.toggle('show');
      iconClose.classList.toggle('show');
      menuList.classList.toggle('show');
    }, 300);
  };

  if(iconMenu.classList.contains('show')) {
    menuToggle.addEventListener('click', openToggle);
  } else {
    menuToggle.addEventListener('click', closeToggle);
  }
  
}
